import { render } from "./VabeneEditCustomerPage.vue?vue&type=template&id=4f26da51&ts=true"
import script from "./VabeneEditCustomerPage.vue?vue&type=script&lang=ts"
export * from "./VabeneEditCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__